import { render } from "./EmbeddingModelCard.vue?vue&type=template&id=472266b2&scoped=true&ts=true"
import script from "./EmbeddingModelCard.vue?vue&type=script&lang=ts"
export * from "./EmbeddingModelCard.vue?vue&type=script&lang=ts"

import "./EmbeddingModelCard.vue?vue&type=style&index=0&id=472266b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472266b2"]])

export default __exports__